import { createAction } from '@reduxjs/toolkit';

export const CONTACTS_SORTED_BY_ACTION_TYPE = 'saga/contactsSortedBy';
export const contactsSortedByAction = createAction(CONTACTS_SORTED_BY_ACTION_TYPE);
